/* Little Backpack — PDP enhancements (vanilla JS, no framework).
   - Add to Cart button shows the live line total: "Add to cart — Rs.{price×qty}".
   - The % discount badge updates with the selected variant.
   - The "Order on WhatsApp" message stays in sync with the selected variant.
   Reads variant data from <script data-lb-pdp> emitted by lb-pdp-enhance.liquid. */
(function () {
  var dataEl = document.querySelector('[data-lb-pdp]');
  if (!dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = data.variants || {};
  var productTitle = data.title || '';

  var form = document.querySelector('product-form form, form[data-type="add-to-cart-form"]');
  if (!form) return;

  var idInput = form.querySelector('[name="id"]');
  var qtyInput = form.querySelector('input[name="quantity"], .quantity__input');
  var submitSpan = document.querySelector('.product-form__submit > span');
  var baseLabel = submitSpan ? submitSpan.textContent.trim() : 'Add to cart';
  var badgeEl = document.querySelector('[data-lb-discount]');
  var waLink = document.querySelector('[data-lb-wa-order]');

  function money(cents) {
    var rupees = Math.round((cents || 0) / 100);
    return 'Rs.' + rupees.toLocaleString('en-US');
  }

  function currentVariant() {
    var id = idInput && idInput.value;
    return id && variants[id] ? variants[id] : null;
  }

  function update() {
    var v = currentVariant();
    if (!v) return;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    // Line total on the Add to Cart button (only when purchasable).
    if (submitSpan) {
      var disabled = document.querySelector('.product-form__submit[disabled]');
      var label = submitSpan.textContent.trim();
      var isAddLabel = /add to cart/i.test(label) || label === baseLabel;
      if (!disabled && isAddLabel) {
        submitSpan.textContent = baseLabel + ' — ' + money(v.price * qty);
      }
    }

    // Discount badge.
    if (badgeEl) {
      if (v.compare && v.compare > v.price) {
        var pct = Math.round((1 - v.price / v.compare) * 100);
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.hidden = false;
      } else {
        badgeEl.hidden = true;
      }
    }

    // WhatsApp message.
    if (waLink) {
      var base = waLink.getAttribute('data-wa-base') || '';
      var hasVariant = v.title && v.title !== 'Default Title';
      var msg = "Hi! I'd like to order: " + productTitle + (hasVariant ? ' (' + v.title + ')' : '');
      waLink.setAttribute('href', base + encodeURIComponent(msg));
    }
  }

  // React to quantity changes.
  if (qtyInput) {
    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);
  }

  // React to variant changes. Dawn updates [name="id"] on its own change
  // handler; run just after so we read the new value.
  form.addEventListener('change', function () { setTimeout(update, 60); });
  if (idInput) {
    new MutationObserver(update).observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }
  document.addEventListener('shopify:section:load', update);

  update();
})();
